export default {
  HAS_PERMISSION_SETTED: store => store.permissions && Object.keys(store.permissions).length > 0,
  HAS_PERMISSION_IN_AREA: store => ({area, action}) => {
    if (store.permissions && store.permissions[area]) {
      if (action === 'SHOW') {
        return store.permissions[area].length > 0
      } else {
        const haveAction = store.permissions[area].includes(action)
        const includeAll = store.permissions[area].includes('ALL')
        return haveAction || includeAll
      }
    }
    return false
  },
  GET_USERNAME: store => store.username,
  GET_SHORT_USERNAME: store => store.username.substr(0, 3) + '...',
  GET_EXPIRE_STATUS: store => store.expired,
  GET_USER_ID: store => store.userId,
  SERVER_URL: store => store.serverURL
}



// WEBPACK FOOTER //
// ./src/view/login/state/getters.js